import { Avatar } from "antd";
import { currencySymbols } from "../utils/jobMapping";
import "./Components.css";

const JobTitle = ({ jobData }) => {
  return (
      <div className="job-title-inline">
        <Avatar
            size={50}
            src={jobData?.image}
            style={{ backgroundColor: "#f5f5f5" }}
        >
          {jobData?.title?.charAt(0)?.toUpperCase() || "A"}
        </Avatar>

        <div className="job-title-inline-info">
          <span className="job-title-text">{jobData?.title}</span>
        <span className="job-salary">
  {jobData?.currency && (jobData?.minimum || jobData?.maximum) ? (
    <>
      {jobData?.minimum && !isNaN(Number(jobData.minimum)) &&
        `${currencySymbols[jobData.currency] || ""} ${Number(jobData.minimum).toLocaleString()}`}
      {jobData?.minimum && jobData?.maximum &&
       !isNaN(Number(jobData.minimum)) && !isNaN(Number(jobData.maximum)) && " – "}
      {jobData?.maximum && !isNaN(Number(jobData.maximum)) &&
        `${currencySymbols[jobData.currency] || ""} ${Number(jobData.maximum).toLocaleString()}`}
    </>
  ) : null}
</span>

        </div>
      </div>
  );
};

export default JobTitle;
